import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, compose } from "redux";

import { store } from "./_helpers";
import "./index.css";
import Routes from "./routes";
import { CookiesProvider } from "react-cookie";

// import registerServiceWorker from './registerServiceWorker';

// setup fake backend
import { configureFakeBackend } from "./_helpers";
// configureFakeBackend();

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <Routes />
    </Provider>
  </CookiesProvider>,
  document.getElementById("app")
);
//registerServiceWorker();
